var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath0",
    transform: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.06 1023.96 L 1024 1023.96 L 1024 0 L 0.06 0 Z",
    style: {
      fill: "none",
      clipRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, -1, 0, 1024)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.06 1023.96 L 1024 1023.96 L 1024 0 L 0.06 0 Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1024 512 C 1024 794.77 794.77 1024 512 1024 C 229.23 1024 0 794.77 0 512 C 0 256.446 187.231 44.63 432 6.22 L 432 364 L 302 364 L 302 512 L 432 512 L 432 624.8 C 432 753.12 508.438 824 625.39 824 C 681.407 824 740 814 740 814 L 740 688 L 675.438 688 C 611.835 688 592 648.533 592 608.043 L 592 512 L 734 512 L 711.3 364 L 592 364 L 592 6.22 C 836.769 44.63 1024 256.446 1024 512",
    style: {
      fill: "rgb(24, 119, 242)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 711.3 364 L 734 512 L 592 512 L 592 608.043 C 592 648.533 611.835 688 675.438 688 L 740 688 L 740 814 C 740 814 681.407 824 625.39 824 C 508.438 824 432 753.12 432 624.8 L 432 512 L 302 512 L 302 364 L 432 364 L 432 6.22 C 458.067 2.13 484.784 0 512 0 C 539.216 0 565.933 2.13 592 6.22 L 592 364 L 711.3 364",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnFacebook);
export default __webpack_public_path__ + "static/media/btn_facebook.e2a58428101803ae0493c4ac594298bd.svg";
export { ForwardRef as ReactComponent };